module.exports = __webpack_public_path__ + "img/LOGO_letter_1.27aa2c59.png";